import React from 'react';
import Styles from './Container.css';
/**
 * @param {string} type Recebe o tipo da tag a ser retornada.
 * @description Container semelhante ao container do Bootstrap
 */
function Container({ fullMobile, type, extraPadding, noPadding, children, ...props }) {
  return (
    <>
      {type === 'div' && (
        <div
          {...props}
          className={`
            ctn 
            ${!!fullMobile ? 'ctn-f-mb' : ''} 
            ${extraPadding ? 'ctn-e-p' : ''} 
            ${noPadding ? 'ctn-rm-p' : ''} 
            ${props.className || ''}
          `.replace(/\s\s+/g, ' ')}
        >
          {children}
        </div>
      )}
      {type === 'ul' && (
        <ul {...props} className={`ctn ${props.className || ''}`}>
          {children}
        </ul>
      )}
      {type === 'article' && (
        <article {...props} className={`ctn ${props.className || ''}`}>
          {children}
        </article>
      )}
      {type === 'section' && (
        <section
          {...props}
          className={`
            ctn 
            ${!!fullMobile ? 'ctn-f-mb' : ''} 
            ${extraPadding ? 'ctn-e-p' : ''} 
            ${noPadding ? 'ctn-rm-p' : ''} 
            ${props.className || ''}
          `.replace(/\s\s+/g, ' ')}
        >
          {children}
        </section>
      )}
      <style jsx>{Styles}</style>
    </>
  );
}

Container.defaultProps = {
  type: 'div',
};

export default Container;
